import { gql } from '@apollo/client';

export const deleteExtendHost = gql`
  mutation deleteExtendHost($input: DeleteExtendHostInput!) {
    deleteExtendHost(input: $input) {
      success
    }
  }
`;
